var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtraViewError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4045 15.3631C12.0014 15.879 11.3767 15.879 10.9735 15.3631C10.5705 14.8471 10.5705 14.0474 10.9735 13.5313L12.3238 11.8028H6.25766C5.69337 11.8028 5.25 11.2352 5.25 10.5128C5.25 9.79047 5.69337 9.2229 6.25766 9.2229H12.3238L10.9534 7.46869C10.5504 6.95277 10.5504 6.15301 10.9534 5.6369C11.155 5.37884 11.4169 5.25 11.6589 5.25C11.9209 5.25 12.1828 5.37903 12.3643 5.6369L15.4478 9.58409C15.6291 9.81623 15.75 10.1517 15.75 10.4871C15.75 10.8226 15.6492 11.1578 15.4478 11.3902L12.4045 15.3631Z",
    fill: "#df9f1c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C4.70842 21 0 16.2916 0 10.5C0 4.70842 4.70842 0 10.5 0C16.2916 0 21 4.70842 21 10.5C21 16.2916 16.2916 21 10.5 21ZM10.5 2.21053C5.92421 2.21053 2.21053 5.92413 2.21053 10.5C2.21053 15.0759 5.92413 18.7895 10.5 18.7895C15.0759 18.7895 18.7895 15.0759 18.7895 10.5C18.7895 5.92413 15.0759 2.21053 10.5 2.21053Z",
    fill: "#df9f1c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraViewError);
export default __webpack_public_path__ + "static/media/extraViewError.9d3b524358197ba9e1fd6326a83c110f.svg";
export { ForwardRef as ReactComponent };